export function DataBlock({ title, data }) {
  return (
    <div className="dark:bg-background-900 flex grow flex-row items-center justify-between rounded-xl bg-white px-4 py-2 lg:flex-col lg:items-start lg:justify-normal lg:space-y-4 lg:rounded-2xl lg:p-8">
      <dt className="text-primary-800 dark:text-primary-100 truncate font-medium lg:text-sm">{title}</dt>
      <dd className="font-semibold lg:mt-1 lg:text-3xl">{data}</dd>
    </div>
  );
}
